export const FAMILY_NOTES = {
  Classic:
    'The Classic mechanism requires both sides of the knob to be pressed before it can be pushed toward the stove and turned to the desired setting. An internal auto-locking design re-engages each time the knob returns to off.',
  Ultimate:
    'The Ultimate mechanism adds a locking component that must be engaged simultaneously with the Push, Press and Turn™ motion. RangeSafe describes it as making it more difficult for young children and adults with cognitive issues to turn on a knob on an unattended stove.',
};

export const PRODUCTS = [
  {
    slug: 'classic-brushed-stainless',
    name: 'Classic Brushed Stainless',
    bucket: 'Classic',
    group: null,
    family: 'Classic',
    size: 'Standard',
    finish: 'Brushed Stainless',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'The original RangeSafe safety knob.',
    description:
      'The original RangeSafe Stove Safety Knob. Both sides of the knob must be pressed before it can be pushed in and turned, helping reduce accidental stove turn-on from bumping into or brushing the knobs. The brushed stainless finish suits most gas and electric ranges.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 3/8 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Listed by RangeSafe for ranges such as LG, GE, Samsung, Whirlpool, JennAir, Maytag, Frigidaire and other similar brands.',
    image: '/assets/products/classic-brushed-stainless.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
    technicalDrawing: '/assets/docs/classic-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Classic Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'classic-black',
    name: 'Classic Black',
    bucket: 'Classic',
    group: null,
    family: 'Classic',
    size: 'Standard',
    finish: 'Black',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'Classic operation in a black finish.',
    description:
      'The Classic Push, Press and Turn™ operation in a black finish, suited to stoves with dark control panels. A straightforward evaluation unit for portfolios with mixed appliances.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 3/8 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Listed by RangeSafe for ranges such as LG, GE, Samsung, Whirlpool, JennAir, Maytag, Frigidaire and other similar brands.',
    image: '/assets/products/classic-black.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
    technicalDrawing: '/assets/docs/classic-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Classic Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'classic-full-metal',
    name: 'Classic Full Metal',
    bucket: 'Classic',
    group: null,
    family: 'Classic',
    size: 'Standard',
    finish: 'Full Metal',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'The Classic mechanism in a full metal body.',
    description:
      'The Classic Push, Press and Turn™ mechanism in a full metal body, finished to suit stainless and metallic control panels.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 3/8 in' },
    weight: '10 oz',
    materials: { body: 'Zinc alloy', bezel: 'Zinc alloy', pushInSides: 'Zinc alloy' },
    fits: 'Listed by RangeSafe for ranges such as LG, GE, Samsung, Whirlpool, JennAir, Maytag, Frigidaire and other similar brands.',
    image: '/assets/products/classic-brushed-stainless.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
    technicalDrawing: '/assets/docs/classic-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Classic Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'classic-compact-brushed-stainless',
    name: 'Compact Brushed Stainless',
    bucket: 'Compact',
    group: null,
    family: 'Classic',
    size: 'Compact',
    finish: 'Brushed Stainless',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'The Classic mechanism in a compact body.',
    description:
      'The Classic Push, Press and Turn™ mechanism in a compact body, sized for stoves with tighter spacing between control knobs. Finished in brushed stainless to match common factory hardware.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/classic-compact-brushed-stainless.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
    technicalDrawing: '/assets/docs/compact-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Compact Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'classic-compact-black',
    name: 'Compact Black',
    bucket: 'Compact',
    group: null,
    family: 'Classic',
    size: 'Compact',
    finish: 'Black',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'Compact body, black finish.',
    description:
      'The Classic mechanism in the compact body and a black finish, sized for stoves with limited space between control knobs. Both sides must be pressed together before the knob can be pushed toward the stove and turned.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Listed by RangeSafe for ranges such as LG, GE, Samsung, Whirlpool, JennAir, Maytag, Frigidaire and other similar brands.',
    image: '/assets/products/classic-compact-black.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
    technicalDrawing: '/assets/docs/compact-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Compact Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'compact-full-metal',
    name: 'Compact Full Metal',
    bucket: 'Compact',
    group: null,
    family: 'Classic',
    size: 'Compact',
    finish: 'Full Metal',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'The Classic mechanism in a compact full metal body.',
    description:
      'The Classic Push, Press and Turn™ mechanism in a compact full metal body, sized for stoves with tighter control spacing.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 in' },
    weight: '10 oz',
    materials: { body: 'Zinc alloy', bezel: 'Zinc alloy', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/classic-compact-brushed-stainless.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
    technicalDrawing: '/assets/docs/compact-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Compact Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'ultimate-brushed-polished',
    name: 'Ultimate Classic Brushed Stainless',
    bucket: 'Specialty',
    group: 'Ultimate Classic',
    family: 'Ultimate',
    size: 'Standard',
    finish: 'Brushed Stainless & Polished Mix',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'The Ultimate mechanism with locking component.',
    description:
      'The Ultimate knob adds a locking component that requires simultaneous activation with the Push, Press and Turn™ motion — an additional layer RangeSafe describes as making it more difficult for young children and adults with cognitive issues to turn on a knob on an unattended stove. Two-tone brushed stainless and polished finish.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 3/8 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Listed by RangeSafe for ranges from brands such as LG, GE, Samsung, Whirlpool, JennAir, Maytag, Frigidaire and others.',
    image: '/assets/products/ultimate-brushed-polished.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
    technicalDrawing: '/assets/docs/ultimate-classic-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Ultimate Classic Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'ultimate-classic-black',
    name: 'Ultimate Classic Black',
    bucket: 'Specialty',
    group: 'Ultimate Classic',
    family: 'Ultimate',
    size: 'Standard',
    finish: 'Black',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'The Ultimate locking mechanism in black.',
    description:
      'The Ultimate locking mechanism in a black finish — the lock and the Push, Press and Turn™ motion engaged together on a knob suited to dark control panels.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 3/8 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Listed by RangeSafe for ranges from brands such as LG, GE, Samsung, Whirlpool, JennAir, Maytag, Frigidaire and others.',
    image: '/assets/products/ultimate-classic-black.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
    technicalDrawing: '/assets/docs/ultimate-classic-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Ultimate Classic Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'ultimate-classic-full-metal',
    name: 'Ultimate Classic Full Metal',
    bucket: 'Specialty',
    group: 'Ultimate Classic',
    family: 'Ultimate',
    size: 'Standard',
    finish: 'Full Metal',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'The Ultimate locking mechanism in a full metal body.',
    description:
      'The Ultimate locking mechanism in a full metal body — the lock and the Push, Press and Turn™ motion engaged together.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 3/8 in' },
    weight: '10 oz',
    materials: { body: 'Zinc alloy', bezel: 'Zinc alloy', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/ultimate-brushed-polished.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
    technicalDrawing: '/assets/docs/ultimate-classic-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Ultimate Classic Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'ultimate-compact-brushed-polished',
    name: 'Ultimate Compact Brushed Stainless',
    bucket: 'Specialty',
    group: 'Ultimate Compact',
    family: 'Ultimate',
    size: 'Compact',
    finish: 'Brushed Stainless & Polished Mix',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'Ultimate locking mechanism, compact body.',
    description:
      'The Ultimate locking mechanism in the compact body, in the two-tone brushed stainless and polished finish. Intended for stoves with tighter control spacing where the added locking layer is still wanted.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/ultimate-compact-brushed-polished.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
    technicalDrawing: '/assets/docs/ultimate-compact-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Ultimate Compact Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'ultimate-compact-black',
    name: 'Ultimate Compact Black',
    bucket: 'Specialty',
    group: 'Ultimate Compact',
    family: 'Ultimate',
    size: 'Compact',
    finish: 'Black',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'The Ultimate locking mechanism, compact body, black finish.',
    description:
      'The Ultimate locking mechanism in the compact body and a black finish, for stoves with tighter control spacing.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 in' },
    weight: '4 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/ultimate-compact-black.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
    technicalDrawing: '/assets/docs/ultimate-compact-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Ultimate Compact Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'ultimate-compact-full-metal',
    name: 'Ultimate Compact Full Metal',
    bucket: 'Specialty',
    group: 'Ultimate Compact',
    family: 'Ultimate',
    size: 'Compact',
    finish: 'Full Metal',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'The Ultimate locking mechanism, compact full metal body.',
    description:
      'The Ultimate locking mechanism in the compact full metal body, for stoves with tighter control spacing.',
    dims: { height: '1.87 in', topWidth: '1.5 in', bottomWidth: '2 in' },
    weight: '10 oz',
    materials: { body: 'Zinc alloy', bezel: 'Zinc alloy', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/ultimate-compact-brushed-polished.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
    technicalDrawing: '/assets/docs/ultimate-compact-knobs-technical-drawing.png',
    technicalDrawingLabel: 'Ultimate Compact Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'classic-deluxe-brushed-stainless',
    name: 'Deluxe Brushed Stainless',
    bucket: 'Specialty',
    group: 'Deluxe',
    family: 'Classic',
    size: 'Deluxe (Pro-Style)',
    finish: 'Brushed Stainless',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'Scaled for Pro-Style ranges.',
    description:
      'The Classic Deluxe targets larger Pro-Style stoves, which generally have larger stove faces and larger factory knobs. Classic Push, Press and Turn™ operation in brushed stainless.',
    dims: { height: '2 in', topWidth: '1.5 in', bottomWidth: '2 3/4 in' },
    weight: '8 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Designed for larger Pro-Style stoves with larger stove faces and knobs.',
    image: '/assets/products/classic-deluxe-brushed-stainless.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
    technicalDrawing: '/assets/docs/rangesafe-deluxe-dimensions.pdf',
    technicalDrawingLabel: 'Deluxe Stove Safety Knobs™ Technical Drawing',
  },
  {
    slug: 'deluxe-black',
    name: 'Deluxe Black',
    bucket: 'Specialty',
    group: 'Deluxe',
    family: 'Classic',
    size: 'Deluxe (Pro-Style)',
    finish: 'Black',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'The Classic mechanism in a Deluxe black body.',
    description:
      'The Classic Push, Press and Turn™ mechanism in a Deluxe body scaled for larger Pro-Style stoves, in a black finish for dark control panels.',
    dims: { height: '2 in', topWidth: '1.5 in', bottomWidth: '2 3/4 in' },
    weight: '8 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Designed for larger Pro-Style stoves with larger stove faces and knobs.',
    technicalDrawing: '/assets/docs/rangesafe-deluxe-dimensions.pdf',
    technicalDrawingLabel: 'Deluxe Stove Safety Knobs™ Technical Drawing',
    image: '/assets/products/deluxe-black.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
  },
  {
    slug: 'deluxe-full-metal',
    name: 'Deluxe Full Metal',
    bucket: 'Specialty',
    group: 'Deluxe',
    family: 'Classic',
    size: 'Deluxe (Pro-Style)',
    finish: 'Full Metal',
    mechanism: 'Push, Press and Turn™',
    locking: false,
    tagline: 'The Classic mechanism in a Deluxe full metal body.',
    description:
      'The Classic Push, Press and Turn™ mechanism in a Deluxe full metal body scaled for larger Pro-Style stoves.',
    dims: { height: '2 in', topWidth: '1.5 in', bottomWidth: '2 3/4 in' },
    weight: '14 oz',
    technicalDrawing: '/assets/docs/rangesafe-deluxe-dimensions.pdf',
    technicalDrawingLabel: 'Deluxe Stove Safety Knobs™ Technical Drawing',
    materials: { body: 'Zinc alloy', bezel: 'Zinc alloy', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/classic-deluxe-brushed-stainless.png',
    patents: ['9,684,329', '10,452,093', '10,831,230'],
  },
  {
    slug: 'ultimate-deluxe-brushed-polished',
    name: 'Ultimate Deluxe Brushed Stainless',
    bucket: 'Specialty',
    group: 'Deluxe',
    family: 'Ultimate',
    size: 'Deluxe (Pro-Style)',
    finish: 'Brushed Stainless & Polished Mix',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'Ultimate locking mechanism for Pro-Style ranges.',
    description:
      'The Ultimate Deluxe combines the additional locking component with a body scaled for larger Pro-Style stoves. Both the Push, Press and Turn™ motion and the lock must be engaged together, in the two-tone brushed stainless and polished finish.',
    technicalDrawing: '/assets/docs/rangesafe-deluxe-dimensions.pdf',
    technicalDrawingLabel: 'Ultimate Deluxe Stove Safety Knobs™ Technical Drawing',
    dims: { height: '2 in', topWidth: '1.5 in', bottomWidth: '2 3/4 in' },
    weight: '8 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Designed for larger Pro-Style stoves with larger stove faces and knobs.',
    image: '/assets/products/ultimate-deluxe-brushed-polished.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
  },
  {
    slug: 'ultimate-deluxe-black',
    name: 'Ultimate Deluxe Black',
    bucket: 'Specialty',
    group: 'Deluxe',
    family: 'Ultimate',
    size: 'Deluxe (Pro-Style)',
    finish: 'Black',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    locking: true,
    tagline: 'The Ultimate locking mechanism in a Deluxe black body.',
    technicalDrawing: '/assets/docs/rangesafe-deluxe-dimensions.pdf',
    technicalDrawingLabel: 'Ultimate Deluxe Stove Safety Knobs™ Technical Drawing',
    description:
      'The Ultimate locking mechanism in a Deluxe body scaled for larger Pro-Style stoves, in a black finish — the motion and the lock engaged together.',
    dims: { height: '2 in', topWidth: '1.5 in', bottomWidth: '2 3/4 in' },
    weight: '8 oz',
    materials: { body: 'Thermoplastic polymer', bezel: 'Thermoplastic polymer', pushInSides: 'Zinc alloy' },
    fits: 'Designed for larger Pro-Style stoves with larger stove faces and knobs.',
    image: '/assets/products/ultimate-deluxe-black.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
  },
  {
    slug: 'ultimate-deluxe-full-metal',
    name: 'Ultimate Deluxe Full Metal',
    bucket: 'Specialty',
    group: 'Deluxe',
    family: 'Ultimate',
    size: 'Deluxe (Pro-Style)',
    finish: 'Full Metal',
    mechanism: 'Push, Press and Turn™ with Additional Locking Component',
    technicalDrawing: '/assets/docs/rangesafe-deluxe-dimensions.pdf',
    technicalDrawingLabel: 'Ultimate Deluxe Stove Safety Knobs™ Technical Drawing',
    locking: true,
    tagline: 'The Ultimate locking mechanism in a Deluxe full metal body.',
    description:
      'The Ultimate locking mechanism in a Deluxe full metal body scaled for larger Pro-Style stoves — motion and lock engaged together.',
    dims: { height: '2 in', topWidth: '1.5 in', bottomWidth: '2 3/4 in' },
    weight: '14 oz',
    materials: { body: 'Zinc alloy', bezel: 'Zinc alloy', pushInSides: 'Zinc alloy' },
    fits: null,
    image: '/assets/products/ultimate-deluxe-brushed-polished.png',
    patents: ['9,684,329', '10,452,093', '10,831,230', '11,960,315', '12,204,359', 'D1036930'],
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const PRODUCT_BUCKETS = [
  {
    name: 'Classic',
    blurb: 'The original Push, Press and Turn™ knob in the standard body.',
    repImage: '/assets/products/classic-brushed-stainless.png',
    hoverImage: '/assets/products/classic-line-stove.jpg',
  },
  {
    name: 'Compact',
    blurb: 'The Classic mechanism in a compact body for tighter control spacing.',
    repImage: '/assets/products/classic-compact-brushed-stainless.png',
    hoverImage: '/assets/products/compact-line-stove.jpg',
  },
  {
    name: 'Specialty',
    blurb: 'Two specialty models: The Ultimate, a Classic knob with an additional locking mechanism for added safety, and the Deluxe, a larger model designed for Pro-Style stoves and ranges.',
    groups: ['Ultimate Classic', 'Ultimate Compact', 'Deluxe'],
    repImage: '/assets/products/ultimate-brushed-polished.png',
    hoverImage: '/assets/products/specialty-line-stove.jpg',
  },
];

export const siblingsOf = (product) =>
  PRODUCTS.filter((p) => p.slug !== product.slug);

export const COMPATIBILITY_LIMITS = [
  {
    title: 'Flat face surface required',
    body: 'RangeSafe knobs need to adhere to a flat face surface. Stoves with an angled front face are generally not compatible, though some angled-face stoves may still qualify — worth a review.',
  },
  {
    title: 'Protruding LED lighting',
    body: 'If LED lights protrude around the control area, the knobs will not be compatible. Recessed LEDs should be compatible.',
  },
  {
    title: 'Integrated bezels',
    body: 'Stoves with integrated bezels are not compatible. Non-integrated bezels can be removed to enable installation.',
  },
];

export const INSTALL_RESOURCES = {
  guide: {
    title: 'RangeSafe Installation Guide (PDF)',
    href: 'https://www.rangesafe.com/s/NEW-RS-Install-Guide-Word-Doc-edit-june-21st.pdf',
  },
  extension: {
    title: 'Insert Extension Instructions (PDF)',
    href: 'https://static1.squarespace.com/static/5f1a411c9936be4a3a2c9054/t/5f305887b38b9530037ea53b/1597003915729/Final+Extension+PDF.pdf',
  },
  videos: [
    { title: 'How to Install RangeSafe Stove Safety Knobs', href: 'https://vimeo.com/442218789' },
    { title: 'Selecting the Correct Red Insert', href: 'https://vimeo.com/446270251' },
    { title: 'Installing the Insert Extension', href: 'https://vimeo.com/446272964' },
    { title: 'How to Remove a Wrong Red Insert', href: 'https://vimeo.com/446277945' },
    { title: 'How We Ship Your New RangeSafe Stove Safety Knobs', href: 'https://vimeo.com/446261458' },
  ],
};

export const WARRANTY = {
  term: 'RangeSafe knobs are warranted to be free from defects in materials and workmanship for two (2) years from the date of sale.',
  exclusions:
    'Coverage excludes misuse, mishandling, tampering, incorrect installation and damage from specific conditions, per the published warranty.',
  retail: 'RangeSafe also publishes a 30-day money-back policy for retail purchases (unused, undamaged, with all included items; RMA required).',
  support: 'Warranty and support questions: (434) 229-7401 or info@rangesafe.com.',
};
